<script lang="ts">
  import type { Announcement } from "../../types";
  import Icon from "../icon.svelte";
  import Locale from "../locale.svelte";

  export let title = "announcements.plural";
  export let announcements: Announcement[] = [];

  $: hasIcons = announcements.some((a) => a.iconSrc);
</script>

<h2 class="Title">
  <Locale label={title} />
</h2>

<ul>
  {#each announcements as announcement}
    <li class:with-icon={hasIcons}>
      {#if announcement.iconSrc}
        <span class="IconSlot">
          <Icon icon={{ src: announcement.iconSrc }} fill={announcement.iconColor} size={20} />
        </span>
      {/if}
      <div class="Message">
        {@html announcement.message}
      </div>
    </li>
  {:else}
    <li><Locale label="announcements.noAnnouncements" /></li>
  {/each}
</ul>

<style>
  .Title {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.12em;
    line-height: 16px;
    margin: 0;
    padding: 16px 0;
    text-transform: uppercase;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0 0 24px;
  }

  li {
    margin: 0;
    padding: 16px 0 16px 22px;
    position: relative;
    line-height: 20px;
  }

  li.with-icon {
    padding-left: 30px;
  }

  li:first-child {
    border-top: 0;
  }

  .Message :global(*:first-child) {
    margin-top: 0;
  }

  .Message :global(*:last-child) {
    margin-bottom: 0;
  }

  .IconSlot {
    left: 0;
    position: absolute;
  }
</style>
